import React, { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import useProductName from "brand-customization/useProductName";
import { Alert } from "components/bootstrap";
import { Link } from "components/common";
import DataLakeRoutes from "data-lake/Routes";
import { HIDE_LAKE_RETRIEVAL_HELP_TEXT_KEY } from "data-lake/Constants";
import Store from "logic/local-storage/Store";
const RetrievalHelp = () => {
  const { t } = useTranslation("enterprise_data_lake");
  const productName = useProductName();
  const [hideHelpText, setHideHelpText] = useState(Store.get(HIDE_LAKE_RETRIEVAL_HELP_TEXT_KEY) === "true");
  const hideRetrievalHelp = () => {
    Store.set(HIDE_LAKE_RETRIEVAL_HELP_TEXT_KEY, "true");
    setHideHelpText(true);
  };
  return !hideHelpText && /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info", onDismiss: hideRetrievalHelp }, /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "retrieval_help.launch_retrieval", components: { bold: /* @__PURE__ */ React.createElement("b", null) } }), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "retrieval_help.license_usage", values: { productName }, components: { bold: /* @__PURE__ */ React.createElement("b", null) } }), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "retrieval_help.progress_tracking",
      components: { bold: /* @__PURE__ */ React.createElement("b", null), overviewLink: /* @__PURE__ */ React.createElement(Link, { to: DataLakeRoutes.ARCHIVE.LIST }) }
    }
  ));
};
export default RetrievalHelp;
